<template>
  <v-layout>
    <v-flex v-if="reportsPending">
      <v-flex>
        Getting employee shifts...
        <v-progress-linear indeterminate></v-progress-linear>
      </v-flex>
    </v-flex>
    <v-flex v-else>
      <v-layout column full-width>
        <h1>Employee Shift Count</h1>
        <v-layout row align-center>
          <h2 class="mr-2">Period:</h2>
          <template>
            <v-flex>
              <v-menu
                ref="startDateMenu"
                v-model="startDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="Start Date"
                    format="dddd, MM DD YYYY"
                    @change="(value) => (startDate = value)"
                    :value="dateFormatted(startDate)"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :show-current="endDate" v-model="startDate" @input="startDateMenu = false" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
          <template>
            <v-flex>
              <v-menu
                ref="endDateMenu"
                v-model="endDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                lazy
                transition="scale-transition"
                offset-y
                full-width
                min-width="290px"
              >
                <template slot="activator" slot-scope="{ on }">
                  <v-text-field
                    label="End Date"
                    format="dddd, MM DD YYYY"
                    @change="(value) => (endDate = value)"
                    :value="dateFormatted(endDate)"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker :show-current="startDate" v-model="endDate" @input="endDateMenu = false" no-title scrollable>
                </v-date-picker>
              </v-menu>
            </v-flex>
          </template>
          <v-btn @click="reGetRecords" color="primary"> Change Dates </v-btn>
          <v-btn @click="csvExport" color="primary" v-if="report.length > 0">
            Export
            <v-icon>arrow_downward</v-icon>
          </v-btn>
        </v-layout>

        <v-data-table :items="report" :headers="headers" item-key="worksite_id" class="elevation-1">
          <template slot="items" slot-scope="{ item }">
            <tr>
              <td>
                <router-link :to="{ name: 'employeeDetail', params: { employeeId: item.employee_id } }" target="_blank">
                  {{ item.first_name }} {{ item.last_name }}
                </router-link>
              </td>
              <td>
                {{ item.shift_count }}
              </td>
              <td>
                {{ item.hours_worked }}
              </td>
              <td>{{ item.standing }}</td>
            </tr>
          </template>
        </v-data-table>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
import {mapState, mapGetters} from 'vuex';
import {ExportToCsv} from 'export-to-csv';
import _ from "lodash";
import EmployeeName from '@/components/hr/employee-name.vue'

export default {
  components: { EmployeeName },
  computed: {
    ...mapState("userAuth", ["user"]),
    //computedOffset: function () {
    //  return this.limit * (this.page - 1)
    //},
    //pageLength: function () {
    //  return Math.ceil(this.queryTotal / this.limit)
    //},
    formattedQuery: function () {
      return {
        startDate: this.startDate,
        endDate: this.endDate,
        //limit: this.limit,
        //offset: this.computedOffset,
        //page: this.page,
      };
    },
    shiftsByBusiness: function () {
      let businesses = [];
      this.shifts.forEach((s) => {
        if (
          // haven't seen this business yet, create it.
          businesses.filter((b) => b.id == s.client_business_id).length < 1
        ) {
          businesses.push({
            name: s.client_business,
            id: s.client_business_id,
            locations: [],
          });
        }

        if (
          // havent' seen this location yet, create it.
          businesses.find((b) => b.id == s.client_business_id).locations.filter((l) => l.id == s.location_id).length < 1
        ) {
          businesses
            .find((b) => b.id == s.client_business_id)
            .locations.push({
              name: s.location,
              id: s.location_id,
              shifts: [],
            });
        }

        // have the business and the location. add this shift to the location's collection
        businesses
          .find((b) => b.id == s.client_business_id)
          .locations.find((l) => l.id == s.location_id)
          .shifts.push(s);
      });

      return businesses;
    },
  },
  created() {
    this.setUp();
  },
  data: function () {
    return {
      limit: 40,
      page: 1,
      startDateMenu: false,
      endDateMenu: false,
      startDate: this.$moment().subtract(2, "weeks").format("YYYY-MM-DD"),
      endDate: this.$moment().subtract(1, "weeks").format("YYYY-MM-DD"),
      reportsPending: true,
      loadingCsv: false,
      report: {},
      // defaultSort: {
      //   sortBy: "hours_worked",
      //   rowsPerPage: -1, //all
      // },
      headers: [
        { text: "Employee", value: "last_name", sortable: true },
        { text: "Shift Count", value: "shift_count", sortable: true },
        { text: "Hours Worked", value: "hours_worked", sortable: true },
        { text: "Standing", value: "standing" },
      ],
    };
  },

  methods: {
    setUp: function () {
      this.startDate = this.$route.query.startDate || this.startDate;
      this.endDate = this.$route.query.endDate || this.endDate;

      this.getReports();
    },

    dateFormatted: function (date) {
      return date ? this.$moment(date).format("dddd, MMMM D YYYY") : "";
    },

    getReports: function () {
      this.reportsPending = true;
      this.$store
        .dispatch("reports/getEmployeeShiftCountReport", this.formattedQuery)
        .then((report) => {
          this.report = report;
        })
        .catch((err) => {
          console.log(err);
        })
        .finally((res) => {
          this.reportsPending = false;
        });
    },
    csvExport() {
      const options = {
        fieldSeparator: ",",
        quoteStrings: '"',
        decimalSeparator: ".",
        showLabels: true,
        showTitle: false,
        filename: `employee_shift_count_${this.$moment().format("YYYY-MM-DD_HH-mm-ss")}`,
        useTextFile: false,
        useBom: true,
        useKeysAsHeaders: true,
      };

      const reportToExport = this.report.map((user) => {
        return _.pick(user, ["first_name", "last_name", "standing", "shift_count", "hours_worked"]);
      });

      const csvExporter = new ExportToCsv(options);
      csvExporter.generateCsv(reportToExport);
    },
    reGetRecords: function () {
      this.getReports();
    },
  },
};
</script>
